import Vue from 'vue';
import i18n from '@/locales/i18n';
import VeeValidate from 'vee-validate';

import esVee from 'vee-validate/dist/locale/es';
import enVee from 'vee-validate/dist/locale/en';
import frVee from 'vee-validate/dist/locale/fr';
import itVee from 'vee-validate/dist/locale/it';
import deVee from 'vee-validate/dist/locale/de';
import ptVee from 'vee-validate/dist/locale/pt_PT';

// Configuramos la librería
const config = {
  events: 'blur',
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    es: esVee,
    en: enVee,
    fr: frVee,
    it: itVee,
    de: deVee,
    pt: ptVee,
  },
};

// Añadimos la librería a Vue
Vue.use(VeeValidate, config);
